// Auto-generated file from geocoder.js - do not edit manually
// Generated on: 2025-08-19T15:59:17.671Z

export interface GeocodedAddress {
  address: string;
  lat: number;
  lng: number;
  mapCategory: string;
  method: 'coordinates' | 'geocoded' | 'fallback';
  error?: string;
  timestamp: string;
}

export const geocodedAddresses: { [key: string]: GeocodedAddress } = {
  "39.217341473967124, -114.1987696163944": {
    "address": "39.217341473967124, -114.1987696163944",
    "lat": 39.217341473967124,
    "lng": -114.1987696163944,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.666Z"
  },
  "40.59709904710032, -111.85985464743027": {
    "address": "40.59709904710032, -111.85985464743027",
    "lat": 40.59709904710032,
    "lng": -111.85985464743027,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.538538794302966, -111.99331516804001": {
    "address": "40.538538794302966, -111.99331516804001",
    "lat": 40.538538794302966,
    "lng": -111.99331516804001,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.81904114722847, -111.91851211144414": {
    "address": "40.81904114722847, -111.91851211144414",
    "lat": 40.81904114722847,
    "lng": -111.91851211144414,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "14.124210053067497, 38.71706371409174": {
    "address": "14.124210053067497, 38.71706371409174",
    "lat": 14.124210053067497,
    "lng": 38.71706371409174,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "81.56082907527572, -137.21740640811157": {
    "address": "81.56082907527572, -137.21740640811157",
    "lat": 81.56082907527572,
    "lng": -137.21740640811157,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.55234130527016, -111.70980791256085": {
    "address": "38.55234130527016, -111.70980791256085",
    "lat": 38.55234130527016,
    "lng": -111.70980791256085,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.18817277487803, -112.59823976458841": {
    "address": "41.18817277487803, -112.59823976458841",
    "lat": 41.18817277487803,
    "lng": -112.59823976458841,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.59270567823573, -111.66678677525948": {
    "address": "40.59270567823573, -111.66678677525948",
    "lat": 40.59270567823573,
    "lng": -111.66678677525948,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.590862681178194, -111.63841814183455": {
    "address": "40.590862681178194, -111.63841814183455",
    "lat": 40.590862681178194,
    "lng": -111.63841814183455,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "83.99114994875666, -135.88444451639523": {
    "address": "83.99114994875666, -135.88444451639523",
    "lat": 83.99114994875666,
    "lng": -135.88444451639523,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.014664394025296, -115.39178346354338": {
    "address": "41.014664394025296, -115.39178346354338",
    "lat": 41.014664394025296,
    "lng": -115.39178346354338,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.65220552088848, -112.05725457595496": {
    "address": "40.65220552088848, -112.05725457595496",
    "lat": 40.65220552088848,
    "lng": -112.05725457595496,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.918012424846516, -112.35496408804": {
    "address": "40.918012424846516, -112.35496408804",
    "lat": 40.918012424846516,
    "lng": -112.35496408804,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.33281920099406, -112.71290384806427": {
    "address": "41.33281920099406, -112.71290384806427",
    "lat": 41.33281920099406,
    "lng": -112.71290384806427,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "36.00081175981446, 76.00013519104597": {
    "address": "36.00081175981446, 76.00013519104597",
    "lat": 36.00081175981446,
    "lng": 76.00013519104597,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "34.0996166496504, -117.29516925026508": {
    "address": "34.0996166496504, -117.29516925026508",
    "lat": 34.0996166496504,
    "lng": -117.29516925026508,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.8093140664168, -111.62773754442175": {
    "address": "41.8093140664168, -111.62773754442175",
    "lat": 41.8093140664168,
    "lng": -111.62773754442175,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.22555344885867, -116.321764688003": {
    "address": "38.22555344885867, -116.321764688003",
    "lat": 38.22555344885867,
    "lng": -116.321764688003,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "19.828024986077672, -90.52933479719032": {
    "address": "19.828024986077672, -90.52933479719032",
    "lat": 19.828024986077672,
    "lng": -90.52933479719032,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "30.899227372413318, -115.46659883245557": {
    "address": "30.899227372413318, -115.46659883245557",
    "lat": 30.899227372413318,
    "lng": -115.46659883245557,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "34.771270875233775, -111.85376595573197": {
    "address": "34.771270875233775, -111.85376595573197",
    "lat": 34.771270875233775,
    "lng": -111.85376595573197,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-2.946398282529322, -62.36407215482651": {
    "address": "-2.946398282529322, -62.36407215482651",
    "lat": -2.946398282529322,
    "lng": -62.36407215482651,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "42.750740017485484, -110.83434224251651": {
    "address": "42.750740017485484, -110.83434224251651",
    "lat": 42.750740017485484,
    "lng": -110.83434224251651,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.75877284526313, -111.88901420376959": {
    "address": "40.75877284526313, -111.88901420376959",
    "lat": 40.75877284526313,
    "lng": -111.88901420376959,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.82226382506764, -112.30958760842945": {
    "address": "40.82226382506764, -112.30958760842945",
    "lat": 40.82226382506764,
    "lng": -112.30958760842945,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.6504541640334, -112.04365133619906": {
    "address": "40.6504541640334, -112.04365133619906",
    "lat": 40.6504541640334,
    "lng": -112.04365133619906,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.39932932241416, -116.46768401089145": {
    "address": "37.39932932241416, -116.46768401089145",
    "lat": 37.39932932241416,
    "lng": -116.46768401089145,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.03371684776004, -111.82788584568516": {
    "address": "41.03371684776004, -111.82788584568516",
    "lat": 41.03371684776004,
    "lng": -111.82788584568516,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.68259015174129, -111.92783044353928": {
    "address": "40.68259015174129, -111.92783044353928",
    "lat": 40.68259015174129,
    "lng": -111.92783044353928,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "67.00003280375398, 4.000300378479489": {
    "address": "67.00003280375398, 4.000300378479489",
    "lat": 67.00003280375398,
    "lng": 4.000300378479489,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "42.165659581189814, -113.60276315958993": {
    "address": "42.165659581189814, -113.60276315958993",
    "lat": 42.165659581189814,
    "lng": -113.60276315958993,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.444043247630084, -111.70510068791242": {
    "address": "40.444043247630084, -111.70510068791242",
    "lat": 40.444043247630084,
    "lng": -111.70510068791242,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.541705373686625, -111.92005819443125": {
    "address": "40.541705373686625, -111.92005819443125",
    "lat": 40.541705373686625,
    "lng": -111.92005819443125,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-0.8922203048411873, 131.3085116787435": {
    "address": "-0.8922203048411873, 131.3085116787435",
    "lat": -0.8922203048411873,
    "lng": 131.3085116787435,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.10242678189363, -113.57318593250729": {
    "address": "37.10242678189363, -113.57318593250729",
    "lat": 37.10242678189363,
    "lng": -113.57318593250729,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.77173017758098, -111.92219064563334": {
    "address": "40.77173017758098, -111.92219064563334",
    "lat": 40.77173017758098,
    "lng": -111.92219064563334,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.263114169832, -115.20970810038108": {
    "address": "39.263114169832, -115.20970810038108",
    "lat": 39.263114169832,
    "lng": -115.20970810038108,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "24.11552861827852, -110.36729855402334": {
    "address": "24.11552861827852, -110.36729855402334",
    "lat": 24.11552861827852,
    "lng": -110.36729855402334,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.882775906610384, -109.29705720188143": {
    "address": "40.882775906610384, -109.29705720188143",
    "lat": 40.882775906610384,
    "lng": -109.29705720188143,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "43.77323834466221, -120.65590610001188": {
    "address": "43.77323834466221, -120.65590610001188",
    "lat": 43.77323834466221,
    "lng": -120.65590610001188,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "71.27811053907583, -156.76686555262526": {
    "address": "71.27811053907583, -156.76686555262526",
    "lat": 71.27811053907583,
    "lng": -156.76686555262526,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.688369523963054, -111.93147394195789": {
    "address": "40.688369523963054, -111.93147394195789",
    "lat": 40.688369523963054,
    "lng": -111.93147394195789,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.8024855818215, -111.92799055966313": {
    "address": "40.8024855818215, -111.92799055966313",
    "lat": 40.8024855818215,
    "lng": -111.92799055966313,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "32.20674335231689, -110.89144362645314": {
    "address": "32.20674335231689, -110.89144362645314",
    "lat": 32.20674335231689,
    "lng": -110.89144362645314,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.56777688790474, -111.69781589938104": {
    "address": "38.56777688790474, -111.69781589938104",
    "lat": 38.56777688790474,
    "lng": -111.69781589938104,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.69189203417864, -113.1707892538594": {
    "address": "39.69189203417864, -113.1707892538594",
    "lat": 39.69189203417864,
    "lng": -113.1707892538594,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.78789753839964, 44.306359483492265": {
    "address": "39.78789753839964, 44.306359483492265",
    "lat": 39.78789753839964,
    "lng": 44.306359483492265,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.550854906601096, -112.00763063798875": {
    "address": "40.550854906601096, -112.00763063798875",
    "lat": 40.550854906601096,
    "lng": -112.00763063798875,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.28099892131812, -112.04854719558709": {
    "address": "41.28099892131812, -112.04854719558709",
    "lat": 41.28099892131812,
    "lng": -112.04854719558709,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.543210925388614, -111.02192008270322": {
    "address": "40.543210925388614, -111.02192008270322",
    "lat": 40.543210925388614,
    "lng": -111.02192008270322,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.378722155920634, -110.93772457120005": {
    "address": "37.378722155920634, -110.93772457120005",
    "lat": 37.378722155920634,
    "lng": -110.93772457120005,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.68354234795215, -111.83484458386079": {
    "address": "40.68354234795215, -111.83484458386079",
    "lat": 40.68354234795215,
    "lng": -111.83484458386079,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-1.685702202683009, 125.62487312474073": {
    "address": "-1.685702202683009, 125.62487312474073",
    "lat": -1.685702202683009,
    "lng": 125.62487312474073,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.68343958825888, -111.77240999535529": {
    "address": "40.68343958825888, -111.77240999535529",
    "lat": 40.68343958825888,
    "lng": -111.77240999535529,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.69230792889363, -107.80895425391948": {
    "address": "37.69230792889363, -107.80895425391948",
    "lat": 37.69230792889363,
    "lng": -107.80895425391948,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-5.833406828338955, 51.65235960478213": {
    "address": "-5.833406828338955, 51.65235960478213",
    "lat": -5.833406828338955,
    "lng": 51.65235960478213,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "34.207939955174055, -113.54933938245388": {
    "address": "34.207939955174055, -113.54933938245388",
    "lat": 34.207939955174055,
    "lng": -113.54933938245388,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.00807699537548, -113.49712879553387": {
    "address": "40.00807699537548, -113.49712879553387",
    "lat": 40.00807699537548,
    "lng": -113.49712879553387,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.51896180597182, -112.90004997727046": {
    "address": "41.51896180597182, -112.90004997727046",
    "lat": 41.51896180597182,
    "lng": -112.90004997727046,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.569674103577704, 43.70966405720287": {
    "address": "39.569674103577704, 43.70966405720287",
    "lat": 39.569674103577704,
    "lng": 43.70966405720287,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "3.7128282424151706, -75.96818864995652": {
    "address": "3.7128282424151706, -75.96818864995652",
    "lat": 3.7128282424151706,
    "lng": -75.96818864995652,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.312007062852445, -109.24848105139483": {
    "address": "38.312007062852445, -109.24848105139483",
    "lat": 38.312007062852445,
    "lng": -109.24848105139483,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.6791729565541, -112.10765773103972": {
    "address": "41.6791729565541, -112.10765773103972",
    "lat": 41.6791729565541,
    "lng": -112.10765773103972,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "3.948177970284248, 36.18647132290218": {
    "address": "3.948177970284248, 36.18647132290218",
    "lat": 3.948177970284248,
    "lng": 36.18647132290218,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.432796004320004, -111.93782128976524": {
    "address": "40.432796004320004, -111.93782128976524",
    "lat": 40.432796004320004,
    "lng": -111.93782128976524,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.386785244642645, -110.84246861872741": {
    "address": "37.386785244642645, -110.84246861872741",
    "lat": 37.386785244642645,
    "lng": -110.84246861872741,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "35.24151756210802, -111.09035883544205": {
    "address": "35.24151756210802, -111.09035883544205",
    "lat": 35.24151756210802,
    "lng": -111.09035883544205,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.63500409818432, -111.793407647266": {
    "address": "40.63500409818432, -111.793407647266",
    "lat": 40.63500409818432,
    "lng": -111.793407647266,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "23.48561719259785, -179.6848936928482": {
    "address": "23.48561719259785, -179.6848936928482",
    "lat": 23.48561719259785,
    "lng": -179.6848936928482,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "52.85457643157959, -102.38833729994661": {
    "address": "52.85457643157959, -102.38833729994661",
    "lat": 52.85457643157959,
    "lng": -102.38833729994661,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "25.766314128065673, -80.20548460553053": {
    "address": "25.766314128065673, -80.20548460553053",
    "lat": 25.766314128065673,
    "lng": -80.20548460553053,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.64562970853028, -105.09185844561844": {
    "address": "39.64562970853028, -105.09185844561844",
    "lat": 39.64562970853028,
    "lng": -105.09185844561844,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.05905607869916, -111.28794726699091": {
    "address": "37.05905607869916, -111.28794726699091",
    "lat": 37.05905607869916,
    "lng": -111.28794726699091,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.671Z"
  },
  "41.34507192925411, -112.35928712796172": {
    "address": "41.34507192925411, -112.35928712796172",
    "lat": 41.34507192925411,
    "lng": -112.35928712796172,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-16.72332156490995, -64.73593428060626": {
    "address": "-16.72332156490995, -64.73593428060626",
    "lat": -16.72332156490995,
    "lng": -64.73593428060626,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.57251119050881, -111.77357587474793": {
    "address": "40.57251119050881, -111.77357587474793",
    "lat": 40.57251119050881,
    "lng": -111.77357587474793,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.533535301915585, -111.94784279164423": {
    "address": "40.533535301915585, -111.94784279164423",
    "lat": 40.533535301915585,
    "lng": -111.94784279164423,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.98113670539726, -114.2624501457372": {
    "address": "38.98113670539726, -114.2624501457372",
    "lat": 38.98113670539726,
    "lng": -114.2624501457372,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "44.58987837253405, -75.16159203872382": {
    "address": "44.58987837253405, -75.16159203872382",
    "lat": 44.58987837253405,
    "lng": -75.16159203872382,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "33.78006053388228, -85.02509407099231": {
    "address": "33.78006053388228, -85.02509407099231",
    "lat": 33.78006053388228,
    "lng": -85.02509407099231,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-33.90844513141765, 18.569235525589512": {
    "address": "-33.90844513141765, 18.569235525589512",
    "lat": -33.90844513141765,
    "lng": 18.569235525589512,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.045716034253935, -112.02645910075839": {
    "address": "41.045716034253935, -112.02645910075839",
    "lat": 41.045716034253935,
    "lng": -112.02645910075839,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "-33.371863738623105, 22.155073863038744": {
    "address": "-33.371863738623105, 22.155073863038744",
    "lat": -33.371863738623105,
    "lng": 22.155073863038744,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.15150125046753, -114.35912720491314": {
    "address": "38.15150125046753, -114.35912720491314",
    "lat": 38.15150125046753,
    "lng": -114.35912720491314,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "38.27421358176386, -111.40581748422949": {
    "address": "38.27421358176386, -111.40581748422949",
    "lat": 38.27421358176386,
    "lng": -111.40581748422949,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.361237419838716, -114.5478214960806": {
    "address": "39.361237419838716, -114.5478214960806",
    "lat": 39.361237419838716,
    "lng": -114.5478214960806,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.87340793949643, -112.04293868454559": {
    "address": "40.87340793949643, -112.04293868454559",
    "lat": 40.87340793949643,
    "lng": -112.04293868454559,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "45.52225288637547, -122.99542378233437": {
    "address": "45.52225288637547, -122.99542378233437",
    "lat": 45.52225288637547,
    "lng": -122.99542378233437,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "46.466573044994895, -125.44445688194794": {
    "address": "46.466573044994895, -125.44445688194794",
    "lat": 46.466573044994895,
    "lng": -125.44445688194794,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "35.007479834852795, -97.97037427512903": {
    "address": "35.007479834852795, -97.97037427512903",
    "lat": 35.007479834852795,
    "lng": -97.97037427512903,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "33.17182588401801, -111.94667993944638": {
    "address": "33.17182588401801, -111.94667993944638",
    "lat": 33.17182588401801,
    "lng": -111.94667993944638,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.78828466040893, -108.4278007871518": {
    "address": "37.78828466040893, -108.4278007871518",
    "lat": 37.78828466040893,
    "lng": -108.4278007871518,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.25141264773412, -120.20582153291195": {
    "address": "37.25141264773412, -120.20582153291195",
    "lat": 37.25141264773412,
    "lng": -120.20582153291195,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "34.23501451234297, -118.16265065537063": {
    "address": "34.23501451234297, -118.16265065537063",
    "lat": 34.23501451234297,
    "lng": -118.16265065537063,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "16.4769592218941, 145.3566287751203": {
    "address": "16.4769592218941, 145.3566287751203",
    "lat": 16.4769592218941,
    "lng": 145.3566287751203,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "1.2548339841894025, -70.23413274551034": {
    "address": "1.2548339841894025, -70.23413274551034",
    "lat": 1.2548339841894025,
    "lng": -70.23413274551034,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "41.04134286099333, -112.41421661830447": {
    "address": "41.04134286099333, -112.41421661830447",
    "lat": 41.04134286099333,
    "lng": -112.41421661830447,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.63315666940483, -111.98228570951643": {
    "address": "40.63315666940483, -111.98228570951643",
    "lat": 40.63315666940483,
    "lng": -111.98228570951643,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "36.86038314435239, -120.1701135996639": {
    "address": "36.86038314435239, -120.1701135996639",
    "lat": 36.86038314435239,
    "lng": -120.1701135996639,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.585574871061056, -111.6011519739183": {
    "address": "40.585574871061056, -111.6011519739183",
    "lat": 40.585574871061056,
    "lng": -111.6011519739183,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "37.00051881989916, -110.00104168504986": {
    "address": "37.00051881989916, -110.00104168504986",
    "lat": 37.00051881989916,
    "lng": -110.00104168504986,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "39.490943606722865, -111.78030945309648": {
    "address": "39.490943606722865, -111.78030945309648",
    "lat": 39.490943606722865,
    "lng": -111.78030945309648,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.670Z"
  },
  "40.75040339951023, -73.96784288366926": {
    "address": "40.75040339951023, -73.96784288366926",
    "lat": 40.75040339951023,
    "lng": -73.96784288366926,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.671Z"
  },
  "41.53622632568835, -112.89917203446879": {
    "address": "41.53622632568835, -112.89917203446879",
    "lat": 41.53622632568835,
    "lng": -112.89917203446879,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.671Z"
  },
  "40.726682050792895, -111.91098952247619": {
    "address": "40.726682050792895, -111.91098952247619",
    "lat": 40.726682050792895,
    "lng": -111.91098952247619,
    "mapCategory": "utah",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.671Z"
  },
  "26.183891134828894, -112.0701794127423": {
    "address": "26.183891134828894, -112.0701794127423",
    "lat": 26.183891134828894,
    "lng": -112.0701794127423,
    "mapCategory": "world",
    "method": "coordinates",
    "timestamp": "2025-08-19T15:59:17.671Z"
  },
  "301 Wakara Way, Salt Lake City, UT 84108": {
    "address": "301 Wakara Way, Salt Lake City, UT 84108",
    "lat": 40.764051,
    "lng": -111.822704,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:20.223Z"
  },
  "315 S 1400 E, SALT LAKE CITY, UT 84112": {
    "address": "315 S 1400 E, SALT LAKE CITY, UT 84112",
    "lat": 40.762512,
    "lng": -111.849548,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.266Z"
  },
  "40.76407085620636, -111.843603757085": {
    "address": "40.76407085620636, -111.843603757085",
    "lat": 40.762759,
    "lng": -111.889779,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.999Z"
  },
  "115 S 1460 E, Room 383, Salt Lake City, UT 84112": {
    "address": "115 S 1460 E, Room 383, Salt Lake City, UT 84112",
    "lat": 40.766713,
    "lng": -111.847849,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.625Z"
  },
  "40.76746144381872, -111.82493868783116": {
    "address": "40.76746144381872, -111.82493868783116",
    "lat": 40.762759,
    "lng": -111.889779,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:18.917Z"
  },
  "122 S. Central Campus Drive, #304, Salt Lake City, Utah 84112": {
    "address": "122 S. Central Campus Drive, #304, Salt Lake City, Utah 84112",
    "lat": 40.766623,
    "lng": -111.844167,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:22.812Z"
  },
  "257 South 1400 East, 201, SALT LAKE CITY, UT 84112": {
    "address": "257 South 1400 East, 201, SALT LAKE CITY, UT 84112",
    "lat": 40.763571,
    "lng": -111.849569,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.998Z"
  },
  "530 Wakara Way, Salt Lake City, UT 84108": {
    "address": "530 Wakara Way, Salt Lake City, UT 84108",
    "lat": 40.757268,
    "lng": -111.83131,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:19.361Z"
  },
  "200 Central Campus Drive, SALT LAKE CITY, UT 84112": {
    "address": "200 Central Campus Drive, SALT LAKE CITY, UT 84112",
    "lat": 40.76492,
    "lng": -111.846216,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.997Z"
  },
  "135 S 1460 E, Room 819, Salt Lake City, UT 84112": {
    "address": "135 S 1460 E, Room 819, Salt Lake City, UT 84112",
    "lat": 40.766228,
    "lng": -111.847699,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.267Z"
  },
  "260 South Central Campus Drive, Salt Lake City, UT 84112": {
    "address": "260 South Central Campus Drive, Salt Lake City, UT 84112",
    "lat": 40.76342,
    "lng": -111.84455,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:20.352Z"
  },
  "110 CENTRAL CAMPUS DRIVE, SALT LAKE CITY, UT 84112": {
    "address": "110 CENTRAL CAMPUS DRIVE, SALT LAKE CITY, UT 84112",
    "lat": 40.765415,
    "lng": -111.844395,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:22.364Z"
  },
  "40.76646438954634, -111.8263539782659": {
    "address": "40.76646438954634, -111.8263539782659",
    "lat": 40.762759,
    "lng": -111.889779,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:20.710Z"
  },
  "40.768635093523656, -111.82365398967248": {
    "address": "40.768635093523656, -111.82365398967248",
    "lat": 40.762759,
    "lng": -111.889779,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:20.761Z"
  },
  "20 South 2030 East, Salt Lake City, Utah 84112": {
    "address": "20 South 2030 East, Salt Lake City, Utah 84112",
    "lat": 40.769068,
    "lng": -111.833122,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:21.366Z"
  },
  "40.76588426425365, -111.82761097743897": {
    "address": "40.76588426425365, -111.82761097743897",
    "lat": 40.762759,
    "lng": -111.889779,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:21.117Z"
  },
  "421 Wakara Way, Ste 140, Salt Lake City, Utah 84108": {
    "address": "421 Wakara Way, Ste 140, Salt Lake City, Utah 84108",
    "lat": 40.75895,
    "lng": -111.828317,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:21.480Z"
  },
  "375 SOUTH 1530 EAST, SALT LAKE CITY, UT 84112": {
    "address": "375 SOUTH 1530 EAST, SALT LAKE CITY, UT 84112",
    "lat": 40.760936,
    "lng": -111.844951,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:22.026Z"
  },
  "250 South 1850 East, Salt Lake City, UT 84112": {
    "address": "250 South 1850 East, Salt Lake City, UT 84112",
    "lat": 40.763898,
    "lng": -111.840369,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:21.524Z"
  },
  "380 1530 E, Salt Lake City, UT 84112": {
    "address": "380 1530 E, Salt Lake City, UT 84112",
    "lat": 40.761391,
    "lng": -111.846349,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:22.113Z"
  },
  "Merrill Engineering, 50 S Central Campus Dr, Salt Lake City, UT 84112": {
    "address": "Merrill Engineering, 50 S Central Campus Dr, Salt Lake City, UT 84112",
    "lat": 40.768531,
    "lng": -111.84672,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:22.141Z"
  },
  "30 N. Mario Capecchi Dr., HELIX 5N, Salt Lake City, Utah 84112": {
    "address": "30 N. Mario Capecchi Dr., HELIX 5N, Salt Lake City, Utah 84112",
    "lat": 40.77,
    "lng": -111.84008,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.045Z"
  },
  "30 N Mario Capecchi Drive, Salt Lake City, Utah 84112": {
    "address": "30 N Mario Capecchi Drive, Salt Lake City, Utah 84112",
    "lat": 40.77,
    "lng": -111.84008,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.653Z"
  },
  "260 1850 E, Salt Lake City, UT 84112": {
    "address": "260 1850 E, Salt Lake City, UT 84112",
    "lat": 40.763719,
    "lng": -111.839191,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.402Z"
  },
  "Carolyn Tanner Irish Humanities Building, Salt Lake City, UT 84112": {
    "address": "Carolyn Tanner Irish Humanities Building, Salt Lake City, UT 84112",
    "lat": 40.76204,
    "lng": -111.831829,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.735Z"
  },
  "50 S Central Campus Dr #2110, Salt Lake City, UT 84112": {
    "address": "50 S Central Campus Dr #2110, Salt Lake City, UT 84112",
    "lat": 40.768531,
    "lng": -111.84672,
    "mapCategory": "campus",
    "method": "geocoded",
    "timestamp": "2025-07-11T16:49:23.771Z"
  }
};

export default geocodedAddresses;
